import { render, staticRenderFns } from "./PresetDetails.vue?vue&type=template&id=012f748b&scoped=true&lang=pug&"
import script from "./PresetDetails.vue?vue&type=script&lang=ts&"
export * from "./PresetDetails.vue?vue&type=script&lang=ts&"
import style0 from "./PresetDetails.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./PresetDetails.vue?vue&type=style&index=1&id=012f748b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012f748b",
  null
  
)

component.options.__file = "PresetDetails.vue"
export default component.exports